/**
 * Created by razial on 2026-05-18.
 */

class Repeater extends BaseComponent {
    build(config, context) {
        const children = [];

        let items = PrefabBuilder.resolveProperty(this.options.repeat, context);

        if (typeof items === "number") {
            items = Array(items).fill(undefined);
        }

        if (!items || !items.length) {
            return children;
        }

        items.forEach((item, index) => {
            PrefabBuilder.createChildren(config, {
                ...context, item, index, repeater: undefined 
            }).forEach((child) => {
                children.push(child);
            });
        });

        return children;
    }
}

Prefab.registerComponent("Repeater", Repeater);
